const accounting = require('accounting')

const format = (priceValue, country) => {
  const price = parseFloat(priceValue)
  if (country && (country === 'UK' || country === 'US')) {
    return accounting.formatMoney(price, '', 2, ',', '.')
  }

  return accounting.formatMoney(price, '', 2, '.', ',')
}

const symbol = (country) => {
  if (country) {
    if (country === 'UK') {
      return '£'
    } else if (country === 'US') {
      return '$'
    }
  }

  return '€'
}

const formatSymbol = (priceValue, country) => {
  const currency = symbol(country)
  const price = parseFloat(priceValue)
  if (country && (country === 'UK' || country === 'US')) {
    return accounting.formatMoney(price, `${currency} `, 2, ',', '.')
  }

  return accounting.formatMoney(price, `${currency} `, 2, '.', ',')
}

const getFloat = (value) => {
  if (value && !isNaN(value)) {
    return parseFloat(value).toFixed(2)
  }

  return value
}

const getVatAmount = (amount, vat) => {
  if (vat && parseFloat(vat) > 0 && amount !== 0) {
    const vatAmount = parseFloat(amount) * parseFloat(vat) / 100
    return round(vatAmount)
  }

  return 0
}

const round = (price, decimal = 2) => {
  return parseFloat(accounting.formatMoney(price || 0, '', decimal, '', '.'))
}

module.exports = {
  format,
  formatSymbol,
  symbol,
  getFloat,
  getVatAmount,
  round
}
